module.exports = __webpack_public_path__ + "img/news_01.d0215567.jpg";